import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
    connect() {
        const hasSeenSplash = sessionStorage.getItem("hasSeenSplash");
        if (hasSeenSplash) {
            this.element.remove();
            return;
        }
        sessionStorage.setItem("hasSeenSplash", "true");
        if (window.innerWidth < 992) {
            setTimeout(() => {
                this.element.classList.add("hidden");
                setTimeout(() => this.element.remove(), 600);
            }, 2000);
        }
        else {
            this.element.classList.add("hidden");
            setTimeout(() => this.element.remove(), 600);
        }
    }
}
